/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_HintInputs */



/**
* | output |
* | --- |
* | "Seat a final from the top five of the standings: its winner is crowned Champion when the league finishes, instead of the standings leader." |
*
* @param {League_Final_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_hint = /** @type {((inputs?: League_Final_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placez une finale avec les cinq premiers du classement : son vainqueur est couronné Champion à la fin de la ligue, à la place du premier du classement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sienta una final con los cinco primeros de la clasificación: su ganador es coronado Campeón al terminar la liga, en lugar del líder de la clasificación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Monte uma final com os cinco primeiros da classificação: o vencedor é coroado Campeão quando a liga termina, no lugar do líder da classificação.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disponi una finale con i primi cinque della classifica: il vincitore è incoronato Campione alla fine del campionato, al posto del primo in classifica.")
	return /** @type {LocalizedString} */ ("Seat a final from the top five of the standings: its winner is crowned Champion when the league finishes, instead of the standings leader.")
});